import * as sterlingparker from './ScrollButtonGroup.styles.sterlingparker';
import * as betprofessor from './ScrollButtonGroup.styles.betprofessor';
import * as volcanobet from './ScrollButtonGroup.styles.volcanobet';
import * as puntgenie from './ScrollButtonGroup.styles.puntgenie';
import * as junglebet from './ScrollButtonGroup.styles.junglebet';
import * as fiestabet from './ScrollButtonGroup.styles.fiestabet';
import * as puntcity from './ScrollButtonGroup.styles.puntcity';
import * as betgalaxy from './ScrollButtonGroup.styles.betgalaxy';
import * as betroyale from './ScrollButtonGroup.styles.betroyale';
import * as juicybet from './ScrollButtonGroup.styles.juicybet';
import * as goldenrush from './ScrollButtonGroup.styles.goldenrush';
import * as vikingbet from './ScrollButtonGroup.styles.vikingbet';
import * as questbet from './ScrollButtonGroup.styles.questbet';
import * as wellbet from './ScrollButtonGroup.styles.wellbet';
import * as sugarcastle from './ScrollButtonGroup.styles.sugarcastle';
import * as buffalobet from './ScrollButtonGroup.styles.buffalobet';
import * as oldgill from './ScrollButtonGroup.styles.oldgill';
import * as titanbet from './ScrollButtonGroup.styles.titanbet';
import * as gigabet from './ScrollButtonGroup.styles.gigabet';
import * as slambet from './ScrollButtonGroup.styles.slambet';
import * as betstride from './ScrollButtonGroup.styles.betstride';
import * as templebet from './ScrollButtonGroup.styles.templebet';
import * as goldenbet888 from './ScrollButtonGroup.styles.goldenbet888';
import * as hyperbet from './ScrollButtonGroup.styles.hyperbet';
import * as bet777 from './ScrollButtonGroup.styles.bet777';
import * as chromabet from './ScrollButtonGroup.styles.chromabet';
import * as bet575 from './ScrollButtonGroup.styles.bet575';
import * as epicodds from './ScrollButtonGroup.styles.epicodds';
import * as pyramidbet from './ScrollButtonGroup.styles.pyramidbet';
import * as magnumbet from './ScrollButtonGroup.styles.magnumbet';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  sterlingparker,
  betprofessor,
  volcanobet,
  puntgenie,
  junglebet,
  fiestabet,
  puntcity,
  betgalaxy,
  betroyale,
  juicybet,
  goldenrush,
  vikingbet,
  questbet,
  wellbet,
  sugarcastle,
  oldgill,
  buffalobet,
  titanbet,
  gigabet,
  slambet,
  betstride,
  templebet,
  goldenbet888,
  hyperbet,
  bet777,
  chromabet,
  bet575,
  epicodds,
  pyramidbet,
  magnumbet,
};
